/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () =>
        import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard'
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () =>
            import('./views/Dashboard.vue'),
          meta: {
            rule: 'MeViewDashboardntor'
          }
        },

        // =============================================================================
        // Application Routes
        // =============================================================================
        {
          path: '/bulkuploadcourse',
          name: 'BulkUploadCourses',
          component: () =>
            import('@/views/coursebuilder/BulkUploadCourse.vue'),
          meta: {
            pageTitle: 'Bulk Upload Courses',
            rule: 'BuildCourses'
          },
        },
        {
          path: '/bulkuploadSchedules',
          name: 'BulkUploadSchedules',
          component: () =>
            import('@/views/coursebuilder/BulkUploadSchedules.vue'),
          meta: {
            pageTitle: 'Bulk Upload Schedules',
            rule: 'BuildCourses'
          },
        },
        {
          path: '/selectcourse',
          name: 'SelectCourse',
          component: () =>
            import('@/views/coursebuilder/SelectCourse.vue'),
          meta: {
            pageTitle: 'Select Course',
            rule: 'BuildCourses'
          },
        },
        {
          path:'/premiumContent',
          name: 'PremiumContent',
          component: () =>
            import('@/views/coursebuilder/PremiumContent.vue'),
          meta:{
            pageTitle: 'Premium Content',
            rule: 'School', 
          }
        },
        {
          path: '/navigations',
          name: 'NavigationList',
          component: () =>
            import('@/views/coursebuilder/NavigationList.vue'),
          meta: {
            pageTitle: 'Maintain Navigation Maps',
            rule: 'MaintainNavigations'
          },
        },
        {
          path: '/backgrounds',
          name: 'BackgroundList',
          component: () =>
            import('@/views/coursebuilder/BackgroundList.vue'),
          meta: {
            pageTitle: 'Maintain Backgrounds',
            rule: 'MaintainBackgrounds'
          },
        },
        {
          path: '/music',
          name: 'MusicList',
          component: () =>
            import('@/views/coursebuilder/MusicList.vue'),
          meta: {
            pageTitle: 'Maintain Audio / Podcasts',
            rule: 'MaintainMusic'
          },
        },
        {
          path: '/characters',
          name: 'CharacterList',
          component: () =>
            import('@/views/coursebuilder/CharacterList.vue'),
          meta: {
            pageTitle: 'Maintain Characters',
            rule: 'MaintainCharacters'
          }
        },
        {
          path: '/scenes',
          name: 'SceneList',
          component: () =>
            import('@/views/coursebuilder/SceneList.vue'),
          meta: {
            pageTitle: 'Maintain Scenes',
            rule: 'MaintainScenes'
          }
        },
        {
          path: '/builder',
          name: 'CourseBuilder',
          component: () =>
            import('@/views/coursebuilder/CourseBuilder.vue'),
          meta: {
            pageTitle: 'Course Builder: ' + localStorage.getItem("currentModuleName"),
            rule: 'BuildCourses'
          }
        },
        {
          path: '/builderB',
          name: 'CourseBuilderB',
          component: () =>
            import('@/views/coursebuilder/CourseBuilderB.vue'),
          meta: {
            pageTitle: 'Module Based Course Builder',
            // pageTitle: 'Module Based Course Builder: ' + localStorage.getItem("currentModuleName"),
            rule: 'BuildCourses'
          }
        },
        {
          path: '/videos',
          name: 'VideoList',
          component: () =>
            import('@/views/coursebuilder/VideoList.vue'),
          meta: {
            pageTitle: 'Maintain Videos',
            rule: 'MaintainVideos'
          }
        },
        {
          path: '/webcam-test',
          name: 'WebcamTest',
          component: () =>
            import('@/layouts/components/WebcamTest.vue'),
          meta: {
            pageTitle: 'Webcam Test'
          }
        },
        {
          path: '/deviceinfo',
          name: 'DeviceInfo',
          component: () =>
            import('@/layouts/components/DeviceInfo.vue'),
          meta: {
            pageTitle: 'Device Info'
          }
        },
        {
          path: '/sites',
          name: 'SitesList',
          component: () =>
            import('@/views/coursebuilder/SitesList.vue'),
          meta: {
            pageTitle: 'Maintain Sites',
            rule: 'MaintainSites'
          }
        },
        {
          path: '/documenttypes',
          name: 'DocumentTypeList',
          component: () =>
            import('@/views/coursebuilder/DocumentTypeList.vue'),
          meta: {
            pageTitle: 'Maintain Document Types',
            rule: 'MaintainDocumentTypes'
          }
        },
        {
          path: '/languages',
          name: 'LanguagesList',
          component: () =>
            import('@/views/coursebuilder/LanguageList.vue'),
          meta: {
            pageTitle: 'Maintain Languages',
            rule: 'MaintainLanguages'
          }
        },
        {
          path: '/classifications',
          name: 'ClassificationsList',
          component: () =>
            import('@/views/coursebuilder/CourseClassificationList.vue'),
          meta: {
            pageTitle: 'Maintain Classifications',
            rule: 'MaintainClassifications'
          }
        },
        {
          path: '/groups',
          name: 'ModuleGroupList',
          component: () =>
            import('@/views/coursebuilder/ModuleGroupList.vue'),
          meta: {
            pageTitle: 'Maintain Module Groups',
            rule: 'MaintainModuleGroups'
          }
        },
        {
          path: '/users',
          name: 'UsersList',
          component: () =>
            import('@/views/coursebuilder/UsersList.vue'),
          meta: {
            pageTitle: 'Maintain Users',
            rule: 'MaintainUsers'
          }
        },
        {
          path: '/ispringquizzes',
          name: 'iSpringQuizList',
          component: () =>
            import('@/views/coursebuilder/iSpringQuizList.vue'),
          meta: {
            pageTitle: 'Maintain iSpring Quizzes',
            rule: 'MaintainISpringQuizzes'
          }
        },
        {
          path: '/ispringpresentations',
          name: 'iSpringPresentationList',
          component: () =>
            import('@/views/coursebuilder/iSpringPresentationList.vue'),
          meta: {
            pageTitle: 'Maintain iSpring Presentations',
            rule: 'MaintainISpringPresentations'
          }
        },
        {
          path: '/documents',
          name: 'DocumentList',
          component: () =>
            import('@/views/coursebuilder/DocumentList.vue'),
          meta: {
            pageTitle: 'Maintain Documents',
            rule: 'MaintainDocuments'
          }
        },
        {
          path: '/quizzes',
          name: 'QuizList',
          component: () =>
            import('@/views/coursebuilder/Quiz.vue'),
          meta: {
            pageTitle: 'Maintain Quizzes',
            rule: 'MaintainQuizzes'
          }
        },
        {
          path: '/courses',
          name: 'Course',
          component: () =>
            import('@/views/coursebuilder/CourseList.vue'),
          meta: {
            pageTitle: 'Maintain Courses & Modules',
            rule: 'BuildCourses'
          }
        },
        {
          path: '/students',
          name: 'StudentsList',
          component: () =>
            import('@/views/coursebuilder/StudentsList.vue'),
          meta: {
            pageTitle: 'Maintain Students',
            rule: 'MaintainUsers'
          }
        },
        {
          path: '/studentDocs',
          name: 'studentDocs',
          component: () =>
            import('@/views/coursebuilder/StudentsDocs.vue'),
          meta: {
            pageTitle: 'Student Documents',
            rule: 'AssessModerateEvaluate'
          }
        },
        {
          path: '/predefinedcomments',
          name: 'PredefinedComment',
          component: () =>
            import('@/views/assessor/PredefinedComment.vue'),
          meta: {
            pageTitle: 'Maintain Predefined Comments',
            rule: 'AssessModerateEvaluate'
          }
        },
        {
          path: '/assessmentquestions',
          name: 'AssessmentQuestion',
          component: () =>
            import('@/views/assessor/AssessmentQuestion.vue'),
          meta: {
            pageTitle: 'Learner Review Questions ',
            rule: 'MaintainAssessmentQuestions'
          }
        },
        {
          path: '/witnesstestimonyquestion',
          name: 'WitnessTestimonyQuestion',
          component: () =>
            import('@/views/assessor/WitnessTestimonyQuestion.vue'),
          meta: {
            pageTitle: 'Witness Testimony Question',
            rule: 'MaintainAssessmentQuestions'
          }
        },
        {
          path: '/resourcecategory',
          name: 'ResourceCategory',
          component: () =>
            import('@/views/coursebuilder/ResourceCategory.vue'),
          meta: {
            pageTitle: 'Resource Category',
            rule: 'BuildCourses'
          }
        },
        {
          path: '/additionalresources',
          name: 'AdditionalResources',
          component: () =>
            import('@/views/coursebuilder/AdditionalResources.vue'),
          meta: {
            pageTitle: 'Additional Resources',
            rule: 'BuildCourses'
          }
        },
        {
          path: '/practicalquestions',
          name: 'PracticalQuestion',
          component: () =>
            import('@/views/coursebuilder/PracticalQuestion.vue'),
          meta: {
            pageTitle: 'Practical Questions',
            rule: 'MaintainPracticalQuestions'
          }
        },
        {
          path: '/sarsquestions',
          name: 'SARSQuestion',
          component: () =>
            import('@/views/coursebuilder/SARSQuestion.vue'),
          meta: {
            pageTitle: 'SARS Questions',
            rule: 'SiteAdmin'
          }
        },
        {
          path: '/vendors',
          name: 'Vendor',
          component: () =>
            import('@/views/coursebuilder/Vendor.vue'),
          meta: {
            pageTitle: 'Vendors',
            rule: 'MaintainVendors'
          }
        },
        {
          path: '/subscription-report',
          name: 'SubscriptionReport',
          component: () =>
            import('@/views/coursebuilder/SubscriptionReport.vue'),
          meta: {
            pageTitle: 'Subscription Report',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/moduledocuments',
          name: 'Module Documents',
          component: () =>
            import('@/views/coursebuilder/ModuleDocuments.vue'),
          meta: {
            pageTitle: 'Module Documents',
            rule: 'AssessModerateEvaluate'
          },
        },
        {
          path: '/assesstask',
          name: 'AssessTask',
          component: () =>
            import('@/views/assessor/AssessTask.vue'),
          meta: {
            pageTitle: 'Assess Tasks',
            rule: 'Assess'
          }
        },
        {
          path: 'assessor/viewtask',
          name: 'ViewTaskAssess',
          component: () =>
            import('@/views/assessor/ViewTask.vue'),
          meta: {
            pageTitle: 'Assess Task',
            rule: 'Assess'
          }
        },
        {
          path: '/monitor/ViewTask',
          name: 'MonitorViewTask',
          component: () =>
            import('@/views/monitor/monitorviews/ViewTask.vue'),
          meta: {
            pageTitle: 'Monitor Task',
            rule: 'Monitor'
          }
        },
        {
          path: '/moderatetask',
          name: 'ModerateTask',
          component: () =>
            import('@/views/moderator/ModerateTask.vue'),
          meta: {
            pageTitle: 'Moderate Tasks',
            rule: 'Moderate'
          }
        },
        {
          path: 'moderator/viewtask',
          name: 'ViewTaskModerate',
          component: () =>
            import('@/views/moderator/ViewTask.vue'),
          meta: {
            pageTitle: 'Moderate Task',
            rule: 'Moderate'
          }
        },
        {
          path: '/assign',
          name: 'Assign',
          component: () =>
            import('@/views/coursebuilder/Assign.vue'),
          meta: {
            pageTitle: 'Assign',
            rule: 'MaintainUsers'
          }
        },
        {
          path: '/evaluatetask',
          name: 'Evaluate',
          component: () =>
            import('@/views/evaluator/EvaluateTask.vue'),
          meta: {
            pageTitle: 'Evaluate',
            rule: 'Evaluate'
          }
        },
        {
          path: 'evaluator/viewtask',
          name: 'ViewTaskEvaluate',
          component: () =>
            import('@/views/evaluator/ViewTask.vue'),
          meta: {
            pageTitle: 'Evaluate Task',
            rule: 'Evaluate'
          }
        },
        {
          path: '/companies',
          name: 'CompanyList',
          component: () =>
            import('@/views/coursebuilder/CompanyList.vue'),
          meta: {
            pageTitle: 'Maintain Companies',
            rule: 'MaintainUsers'
          }
        },
        {
          path: '/marketingcontent',
          name: 'MarketingVideos',
          component: () =>
            import('@/views/marketer/ManageVideos.vue'),
          meta: {
            pageTitle: 'Manage Marketing Videos',
            rule: 'MaintainMarketingVideos'
          }
        },
        {
          path: '/reports',
          name: 'ReportsList',
          component: () =>
            import('@/views/coursebuilder/ReportsList.vue'),
          meta: {
            pageTitle: 'View Reports',
            rule: 'ViewReports'
          }
        },
        {
          path: '/profile',
          name: 'Profile',
          component: () =>
            import('@/views/pages/Profile.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/guardians',
          name: 'GuardiansList',
          component: () =>
            import('@/views/coursebuilder/GuardiansList.vue'),
          meta: {
            pageTitle: 'Maintain Guardians',
            rule: 'MaintainUsers'
          }
        },
        {
          path: '/add-shortcourse',
          name: 'AddShortCourse',
          component: () =>
            import('@/views/coursebuilder/AddShortCourses.vue'),
          meta: {
            pageTitle: 'Add Short Course',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/shortcourses',
          name: 'ShortCourses',
          component: () =>
            import('@/views/coursebuilder/ShortCourseList.vue'),
          meta: {
            pageTitle: 'Manage Short Courses',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/shortcourse-bundles',
          name: 'ShortCourseBundles',
          component: () =>
            import('@/views/ShortCourseBundles/ShortCourseBundles.vue'),
          meta: {
            pageTitle: 'Bundles',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/add-bundle',
          name: 'AddShortCourseBundle',
          component: () =>
            import('@/views/ShortCourseBundles/AddShortCourseBundle.vue'),
          meta: {
            pageTitle: 'Bundles',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/data-plan-banner',
          name: 'Banners',
          component: () =>
            import('@/views/MobilePlans/DataPlansBanner'),
          meta: {
            pageTitle: 'Banners',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/dataplans',
          name: 'DataPlans',
          component: () =>
            import('@/views/MobilePlans/DataPlans.vue'),
          meta: {
            pageTitle: 'Data Plans',
            rule: 'CEPAdmin'
          }
        },
        {
          path: '/studentdocuments-monitor',
          name: 'StudentDocumentsMonitor',
          component: () =>
            import('@/views/coursebuilder/StudentsDocs.vue'),
          meta: {
            pageTitle: 'Monitor Student Documents',
            rule: 'Monitor'
          }
        },
        {
          path: '/assessments-monitor',
          name: 'Assessments',
          component: () =>
            import('@/views/monitor/AssessmentMonitor.vue'),
          meta: {
            pageTitle: 'Monitor Assessments',
            rule: 'Monitor'
          }
        },
        {
          path: '/bulkupload-feedback',
          name: 'BulkUploadFeedback',
          component: ()=> 
            import('@/views/coursebuilder/BulkUploadFeedback.vue'),
          meta: {
            pageTitle: 'Bulk Upload Feedback',
            rule: 'SiteAdmin'
          }
        },
        
        // {
        //   path: '/manage-short-courses',
        //   name: 'ShortCourses',
        //   component: () =>
        //     import('@/views/coursebuilder/ShortCourses.vue'),
        //   meta: {
        //     pageTitle: 'ShortCourse',
        //     rule: 'CEPAdmin'
        //   }
        // },
      ],
    },


    // =============================================================================
    // FULL PAGE - Course Viewer LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPageCourseViewer.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/story',
          name: 'StoryViewer',
          component: () =>
            import('@/components/courseviewer/CourseViewer.vue'),
          meta: {
            pageTitle: 'Course Viewer',
            rule: 'BuildCourses'
          }
        },
        {
          path: '/quizdraganddropreview',
          name: 'QuizDragAndDropPreview',
          component: () =>
            import('@/views/coursebuilder/QuizDragAndDropPreview.vue'),
          meta: {
            pageTitle: 'Drag And Drop Preview',
            rule: 'BuildCourses'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE - Course Viewer LAYOUTS (DigiCampus)
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiCourseViewer.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/digi/story',
          name: 'DigiStoryViewer',
          component: () =>
            import('@/components/courseviewer/CourseViewer.vue'),
          meta: {
            pageTitle: 'Course Viewer',
            rule: 'BuildCourses'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE - Student LAYOUT
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPageStudentDashboard.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        
      ]
    },
    // =============================================================================
    // FULL PAGE - Digi Student Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiStudentDashboard.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/digi/browsecontent',
          name: 'BrowseContent',
          component: () =>
            import('@/digicampus/pages/BrowseContent.vue'),
          meta: {
            pageTitle: 'Lessons',
            rule: 'Student'
          }
        },
        {
          path: '/digi/HomeworkViewer',
          name: 'HomeworkViewer',
          component: () =>
            import('@/digicampus/pages/HomeworkViewer.vue'),
          meta: {
            pageTitle: 'Homework',
            rule: 'Student'
          }
        },
        {
          path: '/modulebasedviewer',
          name: 'LearningStyleBViewer',
          component: () =>
            import('@/digicampus/courseviewer/DigiLearningStyleBViewer.vue'),
          meta: {
            pageTitle: 'Learning Style B Course Viewer',
            rule: 'admin'
          }
        },
        {
          path: '/my-roster',
          name: 'StudentRoster',
          component: () =>
            import('@/digicampus/pages/StudentRoster.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/my-library',
          name: 'StudentLibrary',
          component: () =>
            import('@/digicampus/pages/StudentLibrary.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/my-classrooms',
          name: 'StudentClassrooms',
          component: () =>
            import('@/digicampus/pages/StudentClassrooms.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/classroom',
          name: 'StudentClassroomSelected',
          component: () =>
            import('@/digicampus/pages/StudentClassroomSelected.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/assessments',
          name: 'StudentClassroomAssessments',
          component: () =>
            import('@/digicampus/pages/StudentClassroomAssessments.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/full-library',
          name: 'FullLibrary',
          component: () =>
            import('@/digicampus/pages/FullLibrary.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/view-book',
          name: 'BookViewer (deprecated)',
          component: () =>
            import('@/digicampus/pages/ResourceViews/BookViewer (deprecated).vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/view-video',
          name: 'HLSVideoViewer',
          component: () =>
            import('@/digicampus/pages/ResourceViews/HLSVideoViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/playvideo',
          name: 'VideoViewer',
          component: () =>
            import('@/digicampus/pages/VideoViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/readpdf-notused',
          name: 'DocumentViewer (deprecated)',
          component: () =>
            import('@/digicampus/pages/DocumentViewer (deprecated).vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/readpdf',
          name: 'DocumentViewer',
          component: () =>
            import('@/digicampus/pages/DocumentViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/playpodcast',
          name: 'PodcastViewer',
          component: () =>
            import('@/digicampus/pages/PodcastViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/livestream',
          name: 'LiveStreamViewer',
          component: () =>
            import('@/digicampus/pages/LiveStreamViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/uploadtask',
          name: 'UploadViewer',
          component: () =>
            import('@/digicampus/pages/UploadViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/presentationviewer',
          name: 'PresentationViewer',
          component: () =>
            import('@/digicampus/pages/PresentationViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/quiztask',
          name: 'QuizTaskViewer',
          component: () =>
            import('@/digicampus/pages/QuizTaskViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/videochat',
          name: 'VideoChatPage',
          component: () =>
            import('@/digicampus/pages/VideoChatPage.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/backpackviewer',
          name: 'BackpackViewer',
          component: () =>
            import('@/digicampus/pages/BackpackViewer.vue'),
          meta: {
            pageTitle: 'BackpackViewer',
            rule: 'Student'
          }
        },
        {
          path: '/fab',
          name: 'FAB',
          component: () =>
            import('@/digicampus/assets/fab-icon-examples.vue'),
          meta: {
            pageTitle: 'FAB Examples',
            rule: 'Admin'
          }
        },
        {
          path: '/addvideo',
          name: 'AddVideo',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddVideo.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/editvideo',
          name: 'EditVideo',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/EditVideo.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/adddocument',
          name: 'AddDocument',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddDocument.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/editdocument',
          name: 'EditDocument',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/EditDocument.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/addpodcast',
          name: 'AddPodcast',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddPodcast.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/addquiz',
          name: 'AddQuiz',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddQuiz.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/addupload',
          name: 'AddUpload',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddUpload.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/editupload',
          name: 'EditUpload',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/EditUpload.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/editquiz',
          name: 'EditQuiz',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/EditQuiz.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/editpodcast',
          name: 'EditPodcast',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/EditPodcast.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/addexternallink',
          name: 'AddExternalLink',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddExternalLink.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
            path: '/editexternallink',
            name: 'EditExternalLink',
            component: () =>
                import ('@/digicampus/pages/ContentComponents/ManageContent/EditExternalLink.vue'),
            meta: {
                pageTitle: '',
                rule: 'Admin'
            }
        },
        
        {
          path: '/addpresentation',
          name: 'AddPresentation',
          component: () =>
            import('@/digicampus/pages/ContentComponents/ManageContent/AddPresentation.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
            path: '/editpresentation',
            name: 'EditPresentation',
            component: () =>
                import ('@/digicampus/pages/ContentComponents/ManageContent/EditPresentation.vue'),
            meta: {
                pageTitle: '',
                rule: 'Admin'
            }
        },
        {
          path: '/chat',
          name: 'Chat',
          component: () =>
            import('@/components/chat/Chat.vue'),
          meta: {
            pageTitle: '',
            rule: 'Admin'
          }
        },
        {
          path: '/play-video',
          name: 'MultimediaVideoViewer',
          component: () =>
            import('@/digicampus/pages/MultimediaVideoViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/resources',
          name: 'StudentAdditionalResources',
          component: () =>
            import('@/digicampus/pages/AdditionalResources.vue')
        },
        // Old FET Student Menu
        {
          path: '/menu',
          name: 'Menu',
          component: () =>
            import('@/components/studentdashboard/Menu.vue'),
          meta: {
            pageTitle: 'Menu',
            rule: 'Student'
          }
        },
        {
          path: '/mentoring',
          name: 'Mentoring',
          component: () =>
            import('@/components/studentdashboard/MentoringMenu.vue'),
          meta: {
            pageTitle: 'Menu',
            rule: 'Student'
          }
        },
        {
          path: '/digi/teacher/viewassessment',
          name: 'TeacherViewAssessment',
          component: () =>
            import('@/views/assessor/ViewTask.vue'),
          meta: {
            pageTitle: 'Assess Task',
            rule: 'Assess'
          }
        },
        {
          path: '/q&a',
          name: 'Q&A',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/Q&A.vue'),
          meta: {
            pageTitle: 'Q&A',
            rule: 'Student'
          }
        },
        {
          path: '/callback',
          name: 'CallBack',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/CallBack.vue'),
          meta: {
            pageTitle: 'Call Back',
            rule: 'Student'
          }
        },
        {
          path: '/media',
          name: 'Media',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/Media.vue'),
          meta: {
            pageTitle: 'Media',
            rule: 'Student'
          }
        },
        {
          path: '/search',
          name: 'Search',
          component: () =>
            import('@/components/studentdashboard/SearchModulesAndTopics.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/time-capture',
          name: 'TimeCapture',
          component: () =>
            import('@/components/studentdashboard/TimeCapture.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/practical-time-capture',
          name: 'PracticalTimeCapture',
          component: () =>
            import('@/components/studentdashboard/PracticalTimeCapture.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/sars-time-capture',
          name: 'SARSTimeCapture',
          component: () =>
            import('@/components/studentdashboard/PracticalTimeCapture.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE - Digi Course Builder LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiCourseBuilder.vue'),
      children: [{
        path: '/digi/builder',
        name: 'DigiCourseBuilder',
        component: () =>
          import('@/views/coursebuilder/CourseBuilder.vue'),
        meta: {
          // pageTitle: 'Course Builder: ' + localStorage.getItem("currentModuleName"),
          rule: 'BuildCourses'
        }
      },
      {
        path: '/digi/backgrounds',
        name: 'DigiBackgrounds',
        component: () =>
          import('@/views/coursebuilder/BackgroundList.vue'),
        meta: {
          pageTitle: 'Maintain Backgrounds',
          rule: 'MaintainBackgrounds'
        },
      },
      {
        path: '/digi/music',
        name: 'DigiMusic',
        component: () =>
          import('@/views/coursebuilder/MusicList.vue'),
        meta: {
          pageTitle: 'Maintain Music / Audio',
          rule: 'MaintainMusic'
        },
      },
      {
        path: '/digi/scenes',
        name: 'DigiScenes',
        component: () =>
          import('@/views/coursebuilder/SceneList.vue'),
        meta: {
          pageTitle: 'Maintain Scenes',
          rule: 'MaintainScenes'
        }
      },
      {
        path: '/digi/navigations',
        name: 'DigiNavigationMaps',
        component: () =>
          import('@/views/coursebuilder/NavigationList.vue'),
        meta: {
          pageTitle: 'Maintain Navigation Maps',
          rule: 'MaintainNavigations'
        },
      },
      {
        path: '/digi/characters',
        name: 'DigiCharacters',
        component: () =>
          import('@/views/coursebuilder/CharacterList.vue'),
        meta: {
          pageTitle: 'Maintain Characters',
          rule: 'MaintainCharacters'
        }
      },
      {
        path: '/digi/videos',
        name: 'DigiVideos',
        component: () =>
          import('@/views/coursebuilder/VideoList.vue'),
        meta: {
          pageTitle: 'Maintain Videos',
          rule: 'MaintainVideos'
        }
      },
      {
        path: '/digi/ispringquizzes',
        name: 'DigiISpringQuizzes',
        component: () =>
          import('@/views/coursebuilder/iSpringQuizList.vue'),
        meta: {
          pageTitle: 'Maintain iSpring Quizzes',
          rule: 'MaintainISpringQuizzes'
        }
      },
      {
        path: '/digi/ispringpresentations',
        name: 'DigiISpringPresentations',
        component: () =>
          import('@/views/coursebuilder/iSpringPresentationList.vue'),
        meta: {
          pageTitle: 'Maintain iSpring Presentations',
          rule: 'MaintainISpringPresentations'
        }
      },
      {
        path: '/digi/documents',
        name: 'DigiDocuments',
        component: () =>
          import('@/views/coursebuilder/DocumentList.vue'),
        meta: {
          pageTitle: 'Maintain Documents',
          rule: 'MaintainDocuments'
        }
      },
      {
        path: '/digi/quizzes',
        name: 'DigiQuizzes',
        component: () =>
          import('@/views/coursebuilder/Quiz.vue'),
        meta: {
          pageTitle: 'Maintain Quizzes',
          rule: 'MaintainQuizzes'
        }
      },
      ]
    },
    // =============================================================================
    // FULL PAGE - Digi Teacher Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiTeacherDashboard.vue'),
      children: [
        {
          path: '/digi/teacher',
          name: 'TeacherSubjects',
          component: () =>
            import('@/digicampus/teacherdashboard/MySubjects.vue'),
          meta: {
            rule: 'Teacher'
          }
        },
        {
          path: '/digi/teacher/browsecontent',
          name: 'TeacherBrowseContent',
          component: () =>
            import('@/digicampus/pages/BrowseContent.vue')
        },
        {
          path: '/digi/teacher/calendar',
          name: 'TeacherCalendar',
          component: () =>
            import('@/digicampus/teacherdashboard/MyCalendar.vue'),
          meta: {
            rule: 'Teacher'
          }
        },
        {
          path: '/digi/teacher/library',
          name: 'TeacherLibrary',
          component: () =>
            import('@/digicampus/libraryadmindashboard/Library.vue'),
          meta: {
            rule: 'Teacher'
          }
        },
        {
          path: '/digi/teacher/assessment',
          name: 'TeacherAssessments',
          component: () =>
            import('@/digicampus/teacherdashboard/MyAssessments.vue'),
        },
        {
          path: '/digi/teacher/resources',
          name: 'TeacherResources',
          component: () =>
            import('@/digicampus/pages/AdditionalResources.vue')
        },
        {
          path: '/digi/teacher/qa',
          name: 'TeacherQA',
          component: () =>
            import('@/digicampus/teacherdashboard/TeacherQA.vue')
        },
        {
          path: '/digi/dashboard',
          name: 'Dashboard',
          component: () =>
            import('@/digicampus/teacherdashboard/Dashboard.vue'),
          meta: {
            rule: 'Teacher'
          }
        },
      ]
    },// =============================================================================
    // FULL PAGE - Parent/Guardian Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageGuardianDashboard.vue'),
      children: [
        {
          path: '/parent/dashboard',
          name: 'ParentDashboard',
          component: () =>
            import('@/digicampus/guardiandashboard/Dashboard.vue'),
          meta: {
            rule: 'Guardian'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE - Digi Teacher Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiProfile.vue'),
      children: [
        {
          path: '/digi/profile',
          name: 'AltProfile',
          component: () =>
            import('@/views/pages/Profile.vue'),
          meta: {
            rule: 'admin'
          }
        },
      ]
    },

    // =============================================================================
    // FULL PAGE - Digi Librarian Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiLibraryAdminDashboard.vue'),
      children: [{
        path: '/digi/library',
        name: 'LibraryAdmin',
        component: () =>
          import('@/digicampus/libraryadmindashboard/Library.vue'),
        meta: {
          rule: 'LibraryAdmin'
        }
      }]
    },

    // =============================================================================
    // FULL PAGE - Digi Mentor Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiMentorDashboard.vue'),
      children: [{
        path: '/mentor-dashboard',
        name: 'MentorDashboard',
        component: () =>
          import('@/digicampus/mentordashboard/Dashboard.vue'),
        meta: {
          rule: 'Mentor'
        }
      }]
    },

    // =============================================================================
    // FULL PAGE - Media Previewer LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPageMediaPreview.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/mediapreviewer',
          name: 'MediaPreviewer',
          component: () =>
            import('@/components/mediapreviewer/MediaPreviewer.vue'),
          meta: {
            pageTitle: 'Media Previewer',
            rule: 'MaintainScenes'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE - Student Profile LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPageStudentProfile.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/viewprofile',
          name: 'StudentProfile',
          component: () =>
            import('@/components/studentdashboard/StudentProfile.vue'),
          meta: {
            pageTitle: 'Profile',
            rule: 'Student'
          }
        },
        {
          path: '/viewassessment',
          name: 'ViewAssessment',
          component: () =>
            import('@/components/studentdashboard/ViewAssessment.vue'),
          meta: {
            pageTitle: 'View Assessment',
            rule: 'Student'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE - Student Profile LAYOUTS (DigiCampus)
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiStudentProfile.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/digi/viewprofile',
          name: 'DigiStudentProfile',
          component: () =>
            import('@/digicampus/studentdashboard/DigiStudentProfile.vue'),
          meta: {
            pageTitle: 'Profile',
            rule: 'Student'
          }
        },
        {
          path: '/digi/viewassessment',
          name: 'DigiViewAssessment',
          component: () =>
            import('@/digicampus/studentdashboard/DigiViewAssessment.vue'),
          meta: {
            pageTitle: 'View Assessment',
            rule: 'Student'
          }
        },
      ]
    },
    // =============================================================================
    // DIGI MAIN FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPageDigiMain.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'DigiLogin',
          component: () =>
            import('@/digicampus/pages/DigiLogin.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/growmybusiness',
          name: 'CokeLogin',
          component: () =>
            import('@/digicampus/pages/DigiLogin.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/portal-select',
          name: 'PortalSelect',
          component: () =>
            import('@/digicampus/pages/SelectPortal.vue')
        },
        {
          path: '/moreinfo',
          name: 'NeedMoreInfo',
          component: () =>
            import('@/digicampus/pages/NeedMoreInfo.vue'),
          meta: {
            rule: 'admin' // remember to change back to Student!!!!
          }
        },
        {
          path: '/digi/selectsite',
          name: 'DigiSelectSite',
          component: () =>
            import('@/digicampus/pages/DigiSelectSite.vue'),
          // meta: {
          //     rule: localStorage.getItem('permissions').split(",",1)
          // }
        },
        {
          path: '/forgot-password',
          name: 'forgotPassword',
          component: () =>
            import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/register',
          name: 'DigiRegister',
          component: () =>
            import('@/digicampus/pages/DigiRegister.vue')
        },
        {
          path: '/unsubscribed',
          name: 'Unsubscribed',
          component: () =>
            import('@/views/pages/Unsubscribed.vue'),
          meta: {
            rule: 'admin'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/admin/login',
          name: 'pageLogin',
          component: () =>
            import('@/views/pages/Login.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/selectsite',
          name: 'SelectSite',
          component: () =>
            import('@/views/pages/SelectSite.vue'),
          // meta: {
          //     rule: localStorage.getItem('permissions').split(",",1)
          // }
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () =>
            import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/pages/error-500',
          name: 'pageError500',
          component: () =>
            import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/mobile-detected',
          name: 'mobileDetected',
          component: () =>
            import('@/views/pages/MobileDetected.vue'),
          meta: {
            //rule: 'admin'
          }
        },
        {
          path: '/not-authorized',
          name: 'page-not-authorized',
          component: () =>
            import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: '*'
          }
        },
      ]
    },
    // =============================================================================
    // SONKE/GEN2 MAIN FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/gen-2/full-page/Main.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/learn',
          name: 'Gen2Learn',
          component: () =>
            import('@/gen-2/pages/Learn.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/calendar',
          name: 'Gen2Calendar',
          component: () =>
            import('@/gen-2/pages/Calendar.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/trade',
          name: 'Gen2Trade',
          component: () =>
            import('@/gen-2/pages/Trade.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/status',
          name: 'Gen2Status',
          component: () =>
            import('@/gen-2/pages/Status.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/wallet',
          name: 'Gen2Wallet',
          component: () =>
            import('@/gen-2/pages/Wallet.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/chat',
          name: 'Gen2Chat',
          component: () =>
            import('@/gen-2/pages/Chat.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/menu-v2',
          name: 'Gen2Menu',
          component: () =>
            import('@/gen-2/pages/Menu.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/programs',
          name: 'Gen2LearningPrograms',
          component: () =>
            import('@/gen-2/pages/LearningPrograms.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/capture-time',
          name: 'Gen2TimeCapture',
          component: () =>
            import('@/components/studentdashboard/TimeCapture.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/capture-practical-time',
          name: 'Gen2PracticalTimeCapture',
          component: () =>
            import('@/components/studentdashboard/PracticalTimeCapture.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/pdfviewer-v2',
          name: 'Gen2DocumentViewer',
          component: () =>
            import('@/digicampus/pages/DocumentViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/playvideo-v2',
          name: 'Gen2VideoViewer',
          component: () =>
            import('@/gen-2/pages/Gen2VideoViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/upload',
          name: 'Gen2UploadViewer',
          component: () =>
            import('@/gen-2/pages/Gen2UploadViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/tasks',
          name: 'Gen2OutcomeTasks',
          component: () =>
            import('@/gen-2/pages/OutcomeTasks.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/mentorships',
          name: 'Gen2Mentorships',
          component: () =>
            import('@/gen-2/pages/Mentorships.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/sonke-mentoring',
          name: 'Gen2Mentoring',
          component: () =>
            import('@/components/studentdashboard/MentoringMenu.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/questions-and-answers',
          name: 'Gen2Q&A',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/Q&A.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/sonke-callback',
          name: 'Gen2CallBack',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/CallBack.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/sonke-media',
          name: 'Gen2Media',
          component: () =>
            import('@/components/studentdashboard/mentoringmenucomponents/Media.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/sonke-chat',
          name: 'Gen2MentorChat',
          component: () =>
            import('@/components/chat/Chat.vue'),
          meta: {
            rule: 'Admin'
          }
        },
        {
          path: '/sonke-profile',
          name: 'Gen2StudentProfile',
          component: () =>
            import('@/gen-2/pages/Profile.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/progress',
          name: 'Gen2CourseProgress',
          component: () =>
            import('@/gen-2/pages/Progress.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/review-tasks',
          name: 'Gen2ReviewTasks',
          component: () =>
            import('@/gen-2/pages/ReviewTasks.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/campus',
          name: 'Gen2Campus',
          component: () =>
            import('@/gen-2/pages/Campus.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/support',
          name: 'Gen2Support',
          component: () =>
            import('@/gen-2/pages/Support.vue'),
          meta: {
            rule: 'Student'
          }
        },
      ]
    },

    // =============================================================================
    // FULL PAGE - Public Student Dashboard LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPagePublicStudentDashboard.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/public/dashboard',
          name: 'PublicStudentDashboard',
          component: () =>
            import('@/views/publicstudent/Dashboard.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/public/programs',
          name: 'PublicLearningPrograms',
          component: () =>
            import('@/gen-2/pages/LearningPrograms.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/public/tasks',
          name: 'PublicOutcomeTasks',
          component: () =>
            import('@/gen-2/pages/OutcomeTasks.vue'),
          meta: {
            rule: 'Student'
          }
        },
        {
          path: '/public/pdf-reader',
          name: 'PublicDocumentViewer',
          component: () =>
            import('@/digicampus/pages/DocumentViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/public/video-viewer',
          name: 'PublicVideoViewer',
          component: () =>
            import('@/gen-2/pages/Gen2VideoViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
        {
          path: '/public/upload',
          name: 'PublicUploadViewer',
          component: () =>
            import('@/gen-2/pages/Gen2UploadViewer.vue'),
          meta: {
            pageTitle: '',
            rule: 'Student'
          }
        },
      ]
    },
    {
      path: '',
      component: () =>
        import('@/digicampus/full-page/FullPagePrincipalDashboard.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/principal/dashboard',
          name: 'Dashboard',
          component: () =>
            import('@/digicampus/principaldashboard/Dashboard.vue'),
          meta: {
            pageTitle: '',
            rule: 'Principal'
          }
        },
      ]
    },
    {
      path: '/pages/login',
      redirect: '/login'
    },
    {
      path: '/digilogin',
      redirect: '/login'
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach((to, from, next) => {
  // Remove initial loading

  if (from.name) {
    var currentModuleId = localStorage.getItem("currentModule");
    if (to.name == "CourseBuilder") {
      if (currentModuleId) {
        document.location.href = to.path;
      } else {
        //use routing
        router.push({ path: '/selectcourse' });
      }
    }
  }
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

router.beforeEach((to, from, next) => {
  return next();
  //firebase.auth().onAuthStateChanged(() => {
  //  const firebaseCurrentUser = firebase.auth().currentUser;

  //  if (
  //    to.path === "/login" ||
  //    to.path === "/digilogin" ||
  //    to.path === "/forgot-password" ||
  //    to.path === "/pages/error-404" ||
  //    to.path === "/pages/error-500" ||
  //    to.path === "/pages/register" ||
  //    to.path === "/callback" ||
  //    to.path === "/pages/comingsoon" ||
  //    (firebaseCurrentUser)
  //  ) {

  //  }
  //  router.push({ path: '/login' })
  //});

});

export default router